module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.page || _vm.product) ? _c('div', {
    staticClass: "animate fadeIn"
  }, [(_vm.product) ? _c(_vm.productTemplate, _vm._b({
    tag: "component"
  }, 'component', _vm.props, false)) : _vm._e()], 1) : _c('div', {
    staticClass: "p-5"
  }, [_c('loader')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f995c47","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PagePage.vue
// module id = 704
// module chunks = 1